export default "/_next/static/cc0c36205a495ab07c95ead5c0e92719.png";